import React from 'react';
import BodyMap from '@/components/shared/BodyMap';
import { resolveBodyMapGender } from '@/components/shared/resolveBodyMapGender';
import type { TeamHealthAthlete } from '@/types';

interface Props {
  athlete: TeamHealthAthlete;
  selectedRegion: string | null;
  onRegionClick: (region: string) => void;
  teamGender?: string | null;
}

const BodyMapPanel: React.FC<Props> = ({ athlete, selectedRegion, onRegionClick, teamGender }) => {
  const gender = resolveBodyMapGender(athlete, teamGender);
  // Body map shows ALL injuries (active/improving/resolved) so resolved regions
  // render in green. Falls back to active_injuries for older API responses.
  const sourceInjuries = athlete.all_injuries ?? athlete.active_injuries;
  const injuries = sourceInjuries.map(inj => ({
    body_region: inj.body_region,
    status: inj.status,
  }));

  return (
    <div className="cgm-bg-primary border border-[var(--card-border)] p-3">
      {/* Selected athlete */}
      <div className="mb-3 pb-2 border-b border-[var(--card-border)] text-center">
        <div className="text-[10px] uppercase tracking-wider cgm-text-secondary">Selected</div>
        <div className="text-sm font-semibold cgm-text-primary mt-0.5">{athlete.name}</div>
      </div>

      {/* Body Map */}
      <BodyMap
        injuries={injuries}
        onRegionClick={onRegionClick}
        selectedRegion={selectedRegion}
        interactive
        gender={gender}
      />
    </div>
  );
};

export default BodyMapPanel;
